const isTypingTarget = (target) =>
  target instanceof HTMLElement &&
  (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName));

// Focus the help search with "/" or Cmd/Ctrl+K. Bound once per document.
export const initPublicHelpSearch = (root = document) => {
  if (root.documentElement?.dataset.helpSearchShortcut === 'true') return;
  if (root.documentElement) root.documentElement.dataset.helpSearchShortcut = 'true';

  root.addEventListener('keydown', (event) => {
    const isSlash = event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey;
    const isCommandK = event.key.toLowerCase() === 'k' && (event.metaKey || event.ctrlKey);
    if (!isSlash && !isCommandK) return;
    if (isSlash && isTypingTarget(event.target)) return;

    const input = root.querySelector('[data-help-search-input]');
    if (!input) return;

    event.preventDefault();
    input.focus();
    input.select();
  });
};
